import { RaptorAuthRoutes } from './auth.routes';
import { RaptorDashboardRoutes } from './dashboard.routes';
import { RaptorReportsRoutes } from './reports.routes';
import { RaptorAuditRoutes } from './audit.routes';
import { RaptorCPDRoutes } from './cpd.routes';
import { RaptorRoutes } from './routes.routes';
import { RaptorDiaplan } from './diaplan.routes';
import { RaptorUsersRoutes } from './users.routes';
import { RaptorManualRoutes } from './manual.routes';
import { ErrorsRoutes } from '../errors/errors.routes';

export const RaptorPublicRoutes = <>{RaptorAuthRoutes}</>;

export const RaptorPrivateRoutes = (
  <>
    {RaptorDashboardRoutes}
    {RaptorReportsRoutes}
    {RaptorCPDRoutes}
    {RaptorRoutes}
    {RaptorDiaplan}
    {RaptorUsersRoutes}
    {RaptorAuditRoutes}
    {RaptorManualRoutes}
    {ErrorsRoutes}
  </>
);
